import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter} from '@angular/material/core';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormGroup, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {EventService} from '../../../services/event.service';
import {AuthService} from '../../../services/auth.service';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';

import {DayService} from 'src/app/services/day.service';
import {EventDayDialogComponent} from '../event-day-dialog/event-day-dialog.component';
import {ActivityService} from 'src/app/services/activity.service';
import {TeamService} from 'src/app/services/__team.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import {AgendaService} from 'src/app/services/agenda.service';
import {MemberService} from 'src/app/services/member.service';

import {DomSanitizer} from '@angular/platform-browser';
import {ProductService} from 'src/app/services/product.service';
import {ProductItem, Product} from 'src/app/models/product';
import {OrderedService} from 'src/app/services/ordered.service';
import {EnrollmentService} from 'src/app/services/enrollment.service';
import {Enrollment} from 'src/app/models/enrollment';
import {SlotService} from 'src/app/services/slot.service';
import {EventSlotDialogComponent} from '../event-slot-dialog/event-slot-dialog.component';
import {Slot} from 'src/app/models/slot';
import {FrequencyService} from 'src/app/services/frequency.service';
import {TopicService} from 'src/app/services/topic.service';
import {BannerDialogComponent} from '../banner-dialog/banner-dialog.component';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';
import {LetterV2} from 'src/app/models/letter-v2';
import {LetterV2Service} from 'src/app/services/letter-v2.service';
//import {LetterV2DialogComponent} from 'src/app/letters-v2/dialogs/letter-v2-dialog/letter-v2-dialog.component';
import {InviteV2Service} from 'src/app/services/invite-v2.service';
//import {InviteV2DialogComponent} from 'src/app/letters-v2/dialogs/invite-v2-dialog/invite-v2-dialog.component';
//import {LetterV2DialogPreviewComponent} from 'src/app/letters-v2/dialogs/letter-v2-dialog-preview/letter-v2-dialog-preview.component';
import {MemberDataDialogComponent} from '../member-data-dialog/member-data-dialog.component';
import {ConventionCenterService} from 'src/app/services/convention-center.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {LetterSubscriberService} from 'src/app/services/letter-subscriber.service';
import {EmailService} from 'src/app/services/email.service';
import {DepartmentService} from 'src/app/services/department.service';
import {ContextService} from 'src/app/services/context.service';
import {Day} from 'src/app/models/event';
import {FileService} from 'src/app/services/file.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
  styleUrls: [ './event-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent,
    EventDayDialogComponent
  ],
  providers: [
    {provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: 'check'}
  ]
})
export class EventDialogComponent implements OnInit {

  public Editor = ClassicEditor
  public matcher = new FormErrorStateMatcher(); // filter table

  public eventForm: FormGroup;   // store User Form
  public teamRoleForm: FormGroup;
  public pdfForm: FormGroup;   // store User Form

  public displayedSlotsColumns: string[] = [ 'icon', 'name', 'slot_qtd', 'slot_used', 'wait_qtd', 'edit', 'delete' ];
  public displayedColumns: string[] = [ 'icon', 'date', 'name', 'edit', 'delete' ];
  public displayedTeamColumns: string[] = [ 'icon', 'role_name', 'member_name', 'delete' ];
  public displayedPdfColumns: string[] = [ 'icon', 'name', 'delete' ];
  public displayedCertificateColumns: string[] = [ 'icon', 'product_name', 'member_name', 'selected' ];
 
  public displayedCertificateStaffColumns: string[] = [ 'icon', 'member_name', 'role_name', 'selected' ];

  public displayedFrequencyColumns: string[] = [ 'icon', 'member', 'date', 'event', 'type' ];

  public invite: any = {}

  public products: Product[] = []

  public frequencyDataSource: MatTableDataSource<any>

  public subscriptionDataSource: MatTableDataSource<any>
  public staffDataSource: MatTableDataSource<any>

  public enrollments: any[] = [];
  public staffs: any[] = [];

  public allSponsors: any[] = [];

  public sponsorsDataSource: MatTableDataSource<any>
  public displayedSponsorColumns: string[] = [ 'image', 'link', 'delete' ];

  public letterSelected: LetterV2;

  public waiting: any;

  public arrayCertificate: any[] = [];
  public contexts: any[] = [];

  constructor (
    private fs: AngularFireStorage,
    public _letterV2Service: LetterV2Service,
    public _inviteV2Service: InviteV2Service,
    private dialog: MatDialog,
    private _topicService: TopicService,
    public _eventService: EventService,
    public _slotService: SlotService,
    public _frequencyService: FrequencyService,
    public _enrollmentService: EnrollmentService,
    public _memberService: MemberService,
    public _productService: ProductService,
    public _orderedService: OrderedService,
    public _agendaService: AgendaService,
    public _activityService: ActivityService,
    public _dayService: DayService,
    public _teamService: TeamService,
    public _authService: AuthService,
    public _conventionCenterService: ConventionCenterService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    public _sanitizer: DomSanitizer,
    private _spinnerService: SpinnerService,
    public _emailService: EmailService,
    private _departmentService: DepartmentService,
    public _contextService: ContextService,
    private _fileService: FileService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this._eventService.currentEvent = this.data;
    this._eventService.setEdit()
    this._inviteV2Service.invitesDataSource = null
    this._dayService.dayDataSource = null;
    this._slotService.slotDataSource = null;
    this.frequencyDataSource = null;
    this.subscriptionDataSource = null;
    this._letterV2Service.letterDataSource = null;

    this.loadContexts()
    this.loadConventionCenters(this._eventService.currentEvent.location_id)
    this.loadBannerSponsors();

  }

  ngOnInit () {

    this._adapter.setLocale('pt');

    this.eventForm = this._eventService.createForm(this._eventService.currentEvent)
    this.teamRoleForm = this._teamService.createTeamRoleForm();
    this.pdfForm = this._eventService.createPdfForm();

    if (this._eventService.isEdit) {
      //console.log('is edit')
      this._dayService.select(this._eventService.currentEvent.id)
      this._eventService.setPdfDataSource();
      this._slotService.loadSlots(this._eventService.currentEvent.id);

      this._eventService.storedImage_web = this._eventService.currentEvent.image_web
      this._eventService.storedImage_mobile = this._eventService.currentEvent.image_mobile

      this.loadEnrollments()
      //this.loadFrequency()
      this.loadProducts()
      // this.getSubscriptions()
      // this.loadAgendaStaff()
      // this.loadLetters(this._eventService.currentEvent.id);
      //this.loadResponses(this._eventService.currentEvent.id);
    } else {

    }

  }

  ngAfterViewInit () { }

  async loadContexts () {
    if (this._eventService.currentEvent.congress) {
      this.contexts = await this._contextService.loadContexts(true);
    } else {
      this.contexts = await this._contextService.loadContexts(false);
    }
  }

  insert () {
    if (this.eventForm.valid) {
      const entity = this._eventService.createEvent(this.eventForm.getRawValue())
      //console.log(JSON.stringify(entity))
      this._eventService.insert(entity)
        .then((e) => {
          entity.id = e.id;
          this._eventService.currentEvent = entity
          this.eventForm.controls.id.setValue(e.id);
          console.log('inserted: ' + JSON.stringify(entity))
        })

    }
  }

  update () {
    if (this.eventForm.valid) {
      const entity = this._eventService.createEvent(this.eventForm.getRawValue())
      this._eventService.update(entity)
        .then(() => {
          this._eventService.currentEvent = entity
          console.log(JSON.stringify(this._eventService.currentEvent))
        })

    }
  }

  updateImages () {
    this._eventService.updateImages()
  }

  openDayDialog (day) {
    //this.loadActivities(day)

    if (!day) {
      day = new Day()
    }

    const data = {
      event: this._eventService.currentEvent,
      day: day
    } //, activityDataSource: new MatTableDataSource(array)

    const w = window.innerWidth - 360;
    const h = window.innerHeight - 40;

    let dialogRef = this.dialog.open(EventDayDialogComponent, {
      id: "b",
      width: w.toString() + "px",
      height: h.toString() + "px",
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: data
    })


    dialogRef.afterClosed().subscribe(result => {
      console.log("result: " + result)
      this._dayService.select(this._eventService.currentEvent.id)
    })


  }

  deleteDay (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este dia?"}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {
        //return this._dayService.collection('sbccv_event_topics').doc(element.id).delete();
        this._dayService.delete(element.id)
      }
      else {
        return result
      }

    })
  }

  // TEAM ////////////////////////////

  addTeamRole () {
    this._teamService.addTeamRole(
      this._eventService.currentEvent.id,
      "sbccv_events",
      this.teamRoleForm.controls.member_id.value,
      this.teamRoleForm.controls.role_id.value
    )
  }

  removeTeamRole (element) {
    this._teamService.removeTeamRole(
      this._eventService.currentEvent.id,
      "sbccv_events",
      element
    )
  }

  // MATERIAL /////////////////////////////

  uploadFilePdf () {
    if (this._eventService.objectPdf) {
      this._eventService.uploadFilePdf(this._eventService.objectPdf, this.pdfForm.value);
    }

  }

  selectFile (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match('.pdf') == null) {
      this.snackBar.openSnackBar("Apenas arquivos PDF", '', 'info');
      return;
    }

    this._eventService.objectPdf = event.target.files[ 0 ];
    this.pdfForm.controls.original.setValue(event.target.files[ 0 ].name);
  }

  removeFilePdf (element) {

  }

  goToLink (url: string) {
    window.open(url, "_blank");
  }

  getSubscriptions () {

    this.waiting = this._spinnerService.show();

    console.log("this._eventService.currentEvent.id: " + this._eventService.currentEvent.id)
    
    this._productService.loadProductItensByEvent(this._eventService.currentEvent.id)
      .subscribe((result) => {

        let array: any[] = []

        result.forEach(item => {

          //console.log("loadProductItensByEvent id: " + item.payload.doc.id)
          //console.log("loadProductItensByEvent data: " + JSON.stringify(item.payload.doc.data()))

          let prod = this.products.find((e) => {
            return e.id == item.payload.doc.data().product_id;
          })

          //encontra o produto para o qual estamos procurando inscrições 
          // inscrições são pr produto
          // certificados são por evento
          //console.log("prod: " + JSON.stringify(prod))

          if (prod) {

            //console.log('prod: ' + JSON.stringify(prod))

            let productItem = new ProductItem();

            productItem.product_id = prod.id;
            productItem.product_name = prod.name;

            productItem.event_id = item.payload.doc.data().event_id;
            productItem.event_name = item.payload.doc.data().event_name;

            array.push(productItem);
          }

        });

        // localizado produto 
        // preparar certificados
        this.arrayCertificate = [];

        array.forEach((prod_item) => {
          let id = prod_item.product_id;

          //primeiro carrega todas as incrições para o produto em questão
          this._orderedService.loadValidOrdered(id)
            .subscribe((res) => {
              res.forEach((order_item) => {
                //apenas inscrições válidas
                if (order_item.payload.doc.data().returnCode == "00") {
                  //if (order_item.payload.doc.data().member_name.trim() === 'Carlos Manuel de Almeida Brandão') {
                  //  console.log(order_item.payload.doc.data().member_name)
                  //  console.log(order_item.payload.doc.data().member_id)
                  // }
                  //verifica se enrollments contém solicitações de certificados
                  let enroll = this.enrollments.find((e) => {
                    const order_member_id = order_item.payload.doc.data().member_id
                    return e.member_id == order_member_id && e.type == 'participante'
                  })

                  let selected: boolean = false;
                  // esta inscrição está na coleção sbccv_enrolments?
                  if (enroll) {
                    selected = true;
                  }
                  // console.log('sbccv_enrolments ' + selected)
                  // console.log('control_ticket_by_topic' + this._eventService.currentEvent.control_ticket_by_topic)

                  this.arrayCertificate.push({
                    "product_name": prod_item.product_name.substr(0, 40),
                    "product_id": prod_item.product_id,
                    "member_name": order_item.payload.doc.data().member_name,
                    "member_email": order_item.payload.doc.data().member_email,
                    "member_id": order_item.payload.doc.data().member_id,
                    "topic_id": order_item.payload.doc.data().topic_id || '',
                    "topic_name": order_item.payload.doc.data().topic_name || '',
                    "text1": order_item.payload.doc.data().topic_text1 || '',
                    "text2": order_item.payload.doc.data().topic_text2 || '',
                    "text3": order_item.payload.doc.data().topic_text3 || '',
                    "selected": selected
                  });
                  //
                }
              })

              this.arrayCertificate.sort(this.compareMembers)

              this.subscriptionDataSource = new MatTableDataSource(this.arrayCertificate)

            })

        })

        this.waiting.close()

      })
  }

  compareMembers (a, b) {

    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;

  }

  loadProducts () {
    //this._productService.selectProducts()
    this._productService.selectAllProductsNoAnnuities()
      .subscribe((result) => {
        result.forEach((item) => {

          let product = new Product()
          product.id = item.payload.doc.id;
          product.name = item.payload.doc.data().name

          this.products.push(product)

        })
      })
  }

  /*
  loadFrequency () {
    this._frequencyService.selectByEvent(this._eventService.currentEvent.id)
      .subscribe((result) => {
        let array: any[] = []
        result.forEach((item) => {

          let entity = new Frequency()
          entity.id = item.payload.doc.id;
          entity.activity_id = item.payload.doc.data().activity_id
          entity.activity_name = item.payload.doc.data().activity_name
          entity.day_id = item.payload.doc.data().day_id
          entity.day_name = item.payload.doc.data().day_name
          entity.event_id = item.payload.doc.data().event_id
          entity.event_name = item.payload.doc.data().event_name
          entity.member_id = item.payload.doc.data().member_id
          entity.member_name = item.payload.doc.data().member_name
          entity.member_category_id = item.payload.doc.data().member_category_id
          entity.member_category_name = item.payload.doc.data().member_category_name
          entity.topic_id = item.payload.doc.data().topic_id
          entity.topic_name = item.payload.doc.data().topic_name
          entity.type = item.payload.doc.data().type

          let dt: any = item.payload.doc.data().date
          entity.date = new Date(dt.seconds * 1000)

          array.push(entity)

        })

        this.frequencyDataSource = new MatTableDataSource(array);

      })
  }
  */

  loadEnrollments () {

    this._enrollmentService._selectByEvent(this._eventService.currentEvent.id)
      .subscribe((result) => {

        this.enrollments = []

        result.forEach((item) => {

          let enrollment = new Enrollment()

          enrollment.id = item.payload.doc.id;
          enrollment.created = new Date()

          enrollment.event_id = item.payload.doc.data().event_id;
          enrollment.event_name = item.payload.doc.data().event_name;

          enrollment.day_id = item.payload.doc.data().day_id;
          enrollment.day_name = item.payload.doc.data().day_name;

          enrollment.activity_id = item.payload.doc.data().activity_id;
          enrollment.activity_name = item.payload.doc.data().activity_name;

          enrollment.topic_id = item.payload.doc.data().topic_id;
          enrollment.topic_name = item.payload.doc.data().topic_name;

          enrollment.finished = item.payload.doc.data().finished;
          enrollment.member_id = item.payload.doc.data().member_id;
          enrollment.member_name = item.payload.doc.data().member_name;
          //   enrollment.product_id = item.payload.doc.data().product_id;
          //   enrollment.product_name = item.payload.doc.data().product_name;
          enrollment.type = item.payload.doc.data().type;

          enrollment.certificate_url = item.payload.doc.data().certificate_url || '';

          this.enrollments.push(enrollment)

        })

        //  console.log("this.enrollments: " + JSON.stringify(this.enrollments))
      })

  }

  updateEnrollmentUsers () {

    let top = this.eventForm.controls.docUserTop.value ? Number(this.eventForm.controls.docUserTop.value) : 0
    let left = this.eventForm.controls.docUserLeft.value ? Number(this.eventForm.controls.docUserLeft.value) : 0
    let urlQRCodeUser = this.eventForm.controls.urlQRCodeUser.value ? this.eventForm.controls.urlQRCodeUser.value : ""

    this._eventService.updateTopLeftQrcodeUser(top, left, urlQRCodeUser)
      .then(() => {
        //       console.log("success - qrcode coodenates update")
        this.updateCertificateUser()
      })
      .catch((error) => {
        console.log("erro: " + JSON.stringify(error))
        this.snackBar.openSnackBar("Erro", '', 'error');
      })
      .finally(() => {
        // this.updateCertificateUser()
      })

  }

  updateCertificateUser () {

    if (this._eventService.docUsers) {
      this._eventService.uploadDocUsers(this._eventService.docUsers)
      this._eventService.docUsers = null
    } else {
      ///console.log("nenhum arquivo selecionado")
    }

    let array = this.subscriptionDataSource.data

    //console.log('control_ticket_by_topic' + this._eventService.currentEvent.control_ticket_by_topic)
    //console.log(JSON.stringify(array))

    array.forEach((item) => {

      this._enrollmentService.existAsUser(this._eventService.currentEvent.id, item.member_id)
        .subscribe((result) => {

          let exist: any = null;

          result.forEach((e) => {
            exist = e.id;
          })

          if (item.selected) {
            if (!exist) {

              let enrollment: any = {
                created: new Date(),
                event_id: this._eventService.currentEvent.id,
                event_name: this._eventService.currentEvent.name,
                finished: true,
                member_id: item.member_id,
                member_name: item.member_name,

                topic_id: item.topic_id,
                topic_name: item.topic_name,
                topic_text1: item.text1 || '',
                topic_text2: item.text2 || '',
                topic_text3: item.text3 || '',

                type: "participante",
                certificate_url: ""
              }

              // console.log("add - " + item.member_name + " - " + JSON.stringify(enrollment))


              this._enrollmentService.insert(enrollment)
                .then((e) => {
                  this.snackBar.openSnackBar("Sucesso!", '', 'success');
                })
                .catch((error) => {
                  console.log("erro: " + JSON.stringify(error))
                  this.snackBar.openSnackBar("Erro", '', 'error');
                })


            }
          } else {
            if (exist) {
              //     console.log("remove - " + exist)

              this._enrollmentService.remove(exist)
                .then((e) => {
                  this.snackBar.openSnackBar("Sucesso!", '', 'success');
                })
                .catch((error) => {
                  console.log("erro: " + JSON.stringify(error))
                  this.snackBar.openSnackBar("Erro", '', 'error');
                })


            }
          }
        })
    })

  }

  loadAgendaStaff () {
    //this.waiting = this._spinnerService.show()
    console.log("loadAgendaStaff")
    
    this._agendaService.selectByEvent(this._eventService.currentEvent.id)
      .subscribe((result) => {
        result.forEach((item) => {

          //    console.log("item.payload.doc.data().member_id: " + item.payload.doc.data().member_id)

          let enroll = this.enrollments.find((e) => {

            if (item.payload.doc.data().topic_id) {
              return e.member_id == item.payload.doc.data().member_id
                && e.event_id == item.payload.doc.data().event_id
                && e.activity_id == item.payload.doc.data().activity_id
                && e.topic_id == item.payload.doc.data().topic_id
            } else {
              return e.member_id == item.payload.doc.data().member_id
                && e.event_id == item.payload.doc.data().event_id
                && e.activity_id == item.payload.doc.data().activity_id
            }

          })

          let selected: boolean = false;
          let certificate_url: string = "";

          if (enroll) {
            selected = true;
            //   console.log("certificate_url: " + enroll.certificate_url)
            certificate_url = enroll.certificate_url
          }

          let dt: any = item.payload.doc.data().day_date
          let dtFull = new Date(dt.seconds * 1000)

          let dd = dtFull.getDate()
          let mm = dtFull.getMonth() + 1
          let yy = dtFull.getFullYear()
          let dtFormat = dd + "/" + mm + "/" + yy

          this.staffs.push({
            "event_id": item.payload.doc.data().event_id,
            "event_name": item.payload.doc.data().event_name,
            "day_id": item.payload.doc.data().day_id,
            "day_name": item.payload.doc.data().day_name,
            "day_date": dtFull,
            "activity_id": item.payload.doc.data().activity_id,
            "activity_name": item.payload.doc.data().activity_name,
            "topic_id": item.payload.doc.data().topic_id,
            "topic_name": item.payload.doc.data().topic_name,
            "member_id": item.payload.doc.data().member_id,
            "member_name": item.payload.doc.data().member_name,
            "type": item.payload.doc.data().role_name,
            "selected": selected,
            "certificate_url": certificate_url

          })

        })

        this.waiting.close()

        this.staffs.sort(this.compareMembers)
        this.staffDataSource = new MatTableDataSource(this.staffs)

      })

  }

  updateEnrollmentStaff () {

    let top = this.eventForm.controls.docStaffTop.value ? Number(this.eventForm.controls.docStaffTop.value) : 0
    let left = this.eventForm.controls.docStaffLeft.value ? Number(this.eventForm.controls.docStaffLeft.value) : 0
    let urlQRCodeStaff = this.eventForm.controls.urlQRCodeStaff.value ? this.eventForm.controls.urlQRCodeStaff.value : ""

    this._eventService.updateTopLeftQrcodeStaff(top, left, urlQRCodeStaff)
      .then(() => {
        console.log("success - qrcode coodenates staff update")
      })
      .catch((error) => {
        console.log("erro: " + JSON.stringify(error))
        this.snackBar.openSnackBar("Erro", '', 'error');
      })
      .finally(() => {
        this.updateCertificateStaff()
      })

  }

  updateCertificateStaff () {

    if (this._eventService.docStaff) {
      this._eventService.uploadDocStaff(this._eventService.docStaff)
      this._eventService.docStaff = null

    } else {
      console.log("Nenhum arquivo selecionado")
    }

    let eventTopics: any[] = []

    console.log("this._eventService.currentEvent.id: " + this._eventService.currentEvent.id)

    this._topicService.selectByEventId(this._eventService.currentEvent.id)
      .subscribe((topics) => {
        topics.forEach((topic) => {
          eventTopics.push({
            'id': topic.payload.doc.id,
            'name': topic.payload.doc.data().name,
            'text1': topic.payload.doc.data().text1,
            'text2': topic.payload.doc.data().text2,
            'text3': topic.payload.doc.data().text3
          })
        })

        let array = this.staffDataSource.data

        array.forEach((item) => {

          // console.log("item: " + JSON.stringify(item))

          this._enrollmentService.existStaff(item)
            .subscribe((result) => {

              let exist: any = null;
              result.forEach((e) => {
                exist = e.id;
              })

              if (item.selected) {
                if (!exist) {

                  let texts = eventTopics.find((e) => {
                    return e.id == item.topic_id
                  })

                  console.log("texts: " + JSON.stringify(texts))

                  let enrollment: any = {
                    created: new Date(),
                    event_id: item.event_id,
                    event_name: item.event_name,
                    day_id: item.day_id,
                    day_name: item.day_name,
                    day_date: item.day_date,
                    activity_id: item.activity_id,
                    activity_name: item.activity_name,

                    topic_id: item.topic_id || '',
                    topic_name: item.topic_name || '',

                    topic_text1: texts ? texts.text1 || '' : '',
                    topic_text2: texts ? texts.text2 || '' : '',
                    topic_text3: texts ? texts.text3 || '' : '',

                    finished: true,
                    member_id: item.member_id,
                    member_name: item.member_name,
                    certificate_url: "",
                    type: item.type
                  }

                  //  console.log("add - " + item.member_name + " - " + JSON.stringify(enrollment))

                  this._enrollmentService.insert(enrollment)
                    .then((e) => {
                      this.snackBar.openSnackBar("Sucesso!", '', 'success');
                    })
                    .catch((error) => {
                      console.log("erro: " + JSON.stringify(error))
                      this.snackBar.openSnackBar("Erro", '', 'error');
                    })

                }

              } else {

                if (exist) {
                  //     console.log("remove - " + exist)
                  this._enrollmentService.remove(exist)
                    .then((e) => {
                      this.snackBar.openSnackBar("Sucesso!", '', 'success');
                    })
                    .catch((error) => {
                      console.log("erro: " + JSON.stringify(error))
                      this.snackBar.openSnackBar("Erro", '', 'error');
                    })

                }
              }

            })
        })

      })

  }

  goToLinkDoc (target: string) {
    let url: any = "";

    if (target == 'staff')
      url = this.eventForm.controls.docStaff.value
    else if (target == 'user')
      url = this.eventForm.controls.docUsers.value

    window.open(url, "_blank");
  }

  openSlotDialog (element) {

    if (!element) {
      element = new Slot()

      element.event_id = this._eventService.currentEvent.id
      element.event_name = this._eventService.currentEvent.name
    }

    this.dialog.open(EventSlotDialogComponent, {
      id: "b",
      width: '960px',
      height: '590px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: element
    })

  }

  deleteSlot (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta Vaga?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._slotService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete slot error: " + error.message)}
          )
      }
    })
  }

  exportFrequency () {

    let csvFile: any[] = []

    let csvEvent: string;
    csvEvent = "" + ";"
    csvEvent += this._eventService.currentEvent.name + "\r\n";
    csvFile.push(csvEvent)

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'
    csvHeader += 'Data' + ';'
    csvHeader += 'Hora' + ';'
    csvHeader += 'Dia' + ';'
    csvHeader += 'Atividade' + ';'
    csvHeader += 'Topico' + ';'
    csvHeader += 'E/S' + "\r\n"
    csvFile.push(csvHeader)

    this.frequencyDataSource.data.forEach((item) => {

      let dt: Date = new Date(item.date)
      let dd: any = dt.getDate()
      let MM: any = dt.getMonth()
      let yy: any = dt.getFullYear()
      let hh: any = dt.getHours()
      let mm: any = dt.getMinutes()

      MM += 1 // month starts with zero

      let _dt = dd + "/" + MM + "/" + yy
      let _hh = hh + ":" + mm

      let _type: string;
      if (item.type == 'Exit') {
        _type = "Saída"
      } else {
        _type = "Entrada"
      }

      let csvLine: string;
      csvLine = "" + ";"
      csvLine += item.member_name + ';'
      csvLine += _dt + ';'
      csvLine += _hh + ';'
      csvLine += item.day_name + ';'
      csvLine += item.activity_name + ';'
      csvLine += item.topic_name + ';'
      csvLine += _type + "\r\n"

      csvFile.push(csvLine)
    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, "frequencia.csv");
  }

  loadConventionCenters (location_id) {
    this._conventionCenterService.loadConventionCenters(location_id)
  }

  loadBannerSponsors () {
    if (this._eventService.currentEvent.sponsors && this._eventService.currentEvent.sponsors.length > 0) {
      //   console.log('this._eventService.currentEvent.sponsors ' + JSON.stringify(this._eventService.currentEvent.sponsors))
      this.sponsorsDataSource = new MatTableDataSource(this._eventService.currentEvent.sponsors)
    }
  }

  updateBannerSponsor (banner) {

    if (!this._eventService.currentEvent.sponsors) {
      this._eventService.currentEvent.sponsors = []
    }

    this._eventService.currentEvent.sponsors.push(banner)
    this.sponsorsDataSource = new MatTableDataSource(this._eventService.currentEvent.sponsors)

    this._eventService.updateBannerSponsor(this._eventService.currentEvent.id, this._eventService.currentEvent.sponsors)

  }

  removeBannerSponsor (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.link + "<br><br>Excluir este banner?"}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {
        this._eventService.currentEvent.sponsors = this._eventService.currentEvent.sponsors.filter((e) => {
          return e.id != element.id;
        })

        this.sponsorsDataSource = new MatTableDataSource(this._eventService.currentEvent.sponsors)
        //  console.log("this._eventService.currentEvent.sponsors: " + JSON.stringify(this._eventService.currentEvent.sponsors))
        this._eventService.updateBannerSponsor(this._eventService.currentEvent.id, this._eventService.currentEvent.sponsors)
          .then(() => {

            const fsRef: any = this.fs.storage.refFromURL(element.image);
            fsRef.delete();

          })

      }
      else {
        return result
      }

    })


  }

  openBannerDialog (element) {

    let dialogRef = this.dialog.open(BannerDialogComponent, {
      id: "b",
      width: '600px',
      height: '470px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: {'isProduct': false}
    })

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const bannerForm: FormGroup = response[ 0 ];
        const objectBanner: any = response[ 1 ];

        const formData = bannerForm.getRawValue();

        let banner: any = {};

        banner.id = new Date().getTime();
        banner.link = formData.link || '';

        const fsRef: AngularFireStorageReference = this.fs.ref("images/banner_sponsors/" + "banner_" + banner.id + ".png");
        const fsTask: AngularFireUploadTask = fsRef.put(objectBanner);

        fsTask.snapshotChanges().pipe(
          finalize(() => {
            fsRef.getDownloadURL().subscribe(url => {
              banner.image = url;
              this.updateBannerSponsor(banner);
            });
          }))
          .subscribe();
      })
  }

  toggleCheckUsers (checked) {
    //   console.log("checked: " + JSON.stringify(checked))

    this.subscriptionDataSource.data.forEach((item) => {
      item.selected = checked;
    })

  }

  toggleCheckStaff (checked) {
    //   console.log("checked: " + JSON.stringify(checked))

    this.staffDataSource.data.forEach((item) => {
      item.selected = checked;
    })

  }

  /*
loadSponsors () {

   this._sponsorService.select()
       .subscribe((result) => {

           this.allSponsors = result.map(item => {
               let entity = new Sponsor();
               entity.id = item.payload.doc.id;
               entity.name = item.payload.doc.data().name;
               entity.url = item.payload.doc.data().url;
               entity.image = item.payload.doc.data().image;
               return entity;
           });

       })

}

 
sponsorSelected (event) {

   let sponsor = this.allSponsors.find((e) => {
       return e.id == event
   })

   this.eventForm.controls.sponsor_name.setValue(sponsor.name);

}
 

updateBanner () {

   if (this.eventForm.controls.sponsor_id.value) {

       const data_banner: any = {
           'event_id': this._eventService.currentEvent.id,
           'sponsor_id': this.eventForm.controls.sponsor_id.value,
           'sponsor_name': this.eventForm.controls.sponsor_name.value,
           'file': this._eventService.objectBannerEvent
       }

       console.log("data_banner: " + JSON.stringify(data_banner))

       this._eventService.uploadBannerEvent(data_banner)

   }


}
*/




  //////////////////////////////////
  // LETTERS & INVITES
  /////////////////////////////////
/*
  loadLetters (event_id) {
    this._letterV2Service.letters = []

    this._letterV2Service.loadLetters(event_id)
      .subscribe((result) => {
        this._letterV2Service.letters = result.map(item => {
          let entity = new LetterV2();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.subject = item.payload.doc.data().subject;
          entity.type = item.payload.doc.data().type || '0';
          entity.text = item.payload.doc.data().text;
          entity.event_id = item.payload.doc.data().event_id;
          entity.event_name = item.payload.doc.data().event_name;
          entity.isCongress = item.payload.doc.data().isCongress;
          entity.isTemplate = item.payload.doc.data().isTemplate;
          entity.imageTop = item.payload.doc.data().imageTop;
          entity.imageBottom = item.payload.doc.data().imageBottom;
          entity.imageBody = item.payload.doc.data().imageBody;
          return entity;
        });

        this._letterV2Service.letterDataSource = new MatTableDataSource(this._letterV2Service.letters);

      })

  }

  openLetterDialog (entity) {

    let data: LetterV2 = new LetterV2();

    if (entity) {
      data = entity;
    }

    this.dialog.open(LetterV2DialogComponent, {
      width: '820px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      data: {'letter': data, 'event': this._eventService.currentEvent}
    });
  }

  openPreviewDialog (entity) {

    let letter: LetterV2 = entity;

    this.dialog.open(LetterV2DialogPreviewComponent, {
      width: '900px',
      height: '700px',
      panelClass: 'custom-dialog-container',
      data: {'letter': letter, 'event': this._eventService.currentEvent}
    });

  }

  letterSelect (letter) {
    this.letterSelected = letter
    this._inviteV2Service.loadAgendaForInvites(this._eventService.currentEvent.id, this.letterSelected.id)
  }

  openInviteDialog (invite) {
    let data: any = {};

    data.event = this._eventService.currentEvent
    data.letter = this.letterSelected
    data.invite = invite;

    if (data.invite.date_sent) {
      this._inviteV2Service.getById(invite.id)
        .subscribe((result) => {

          data.invite.agenda = result.data().agenda
          data.invite.agenda.forEach((item) => {
            item.day_date = item.day_date.toDate()
          })

          this.showInviteDialog(data)
        })
    } else {
      this.showInviteDialog(data)
    }

  }


  showInviteDialog (data: any) {

    let dialogRef = this.dialog.open(InviteV2DialogComponent, {
      width: '860px',
      height: '540px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe((response) => {

      const action: any = response[ 0 ]

      if (action == 'response') {

        const formData: any = response[ 1 ]
        //console.log("updatedData :" + JSON.stringify(formData))

        let acceptAll: boolean = false
        let countRejection: number = 0;

        formData.forEach(item => {
          // console.log("item: " + JSON.stringify(item.acceptInvite))
          if (!item.acceptInvite) {
            countRejection++
          }
        });

        if (countRejection == 0) {
          acceptAll = true
        } else {
          acceptAll = false
        }

        const updatedData: any = {
          'accept': acceptAll,
          'date_response': new Date(),
          'admin_response': true,
          'agenda': formData,
          'obs': ''
        }

        // console.log("updatedData :" + JSON.stringify(updatedData))


        this._inviteV2Service.registerResponse(data.invite.id, updatedData)
          .then(() => {
            this._inviteV2Service.loadAgendaForInvites(this._eventService.currentEvent.id, this.letterSelected.id)
          })
          .catch((err) => {
            console.log("erro")
          })


      } else if (action == 'invite') {
        //no email
        const data: any = response[ 1 ]
        //console.log(JSON.stringify(data))

        this._inviteV2Service.registerInvite(data, false, "", true) //data, email, obs, admin_invite
          .then((invite) => {
            console.log("invite: " + invite)
            this.snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch((error) => {
            console.log("ERRO:: " + JSON.stringify(error.message));
            this.snackBar.openSnackBar("Erro!", '', 'error')
          })



      }

    })
  }

  makeShipping () {

    this._inviteV2Service.makeShipping(
      this._inviteV2Service.invitesDataSource.data,
      this.letterSelected,
      this._eventService.currentEvent
    )

  }

  loadResponses (event_id) {

    this._inviteV2Service.selectInvites(event_id)
      .subscribe((result) => {

        let members: any = [];
        let member: any = "";
        let letters: any = [];

        const membersActive: any = []
        const membersArchived: any[] = []

        result.forEach((item) => {

          let ltr: any = {};
          ltr = item.payload.doc.data();
          ltr.id = item.payload.doc.id
          letters.push(ltr);


          if (member != item.payload.doc.data().member_name) {
            member = item.payload.doc.data().member_name

            let url_update: string = item.payload.doc.data().url_back
            url_update = url_update.replace("confirm", "update")
            url_update = url_update + ":true"

            // console.log(item.payload.doc.data().member_name)
            // console.log(url_confirm)
            // console.log("------------------------")

            members.push(
              {
                'id': item.payload.doc.data().member_id,
                'name': item.payload.doc.data().member_name,
                'url_update': url_update
              }
            )
          }
        })

        members.forEach((item) => {

          const lettersActive: any[] = []
          const lettersArchived: any[] = []

          let allLettersMember = letters.filter((e) => {
            return e.member_id == item.id
          })

          allLettersMember.forEach((letter) => {
            if (letter.archived) {
              lettersArchived.push(letter)
            } else {
              lettersActive.push(letter)
            }
          })

          // item.letters = allLettersMember;

          if (lettersArchived.length > 0) {
            membersArchived.push({...item, 'letters': lettersArchived})
          }
          if (lettersActive.length > 0) {
            membersActive.push({...item, 'letters': lettersActive})
          }
        })

        //console.log("lettersActive: " + JSON.stringify(membersActive))

        this._inviteV2Service.responsesDataSource = new MatTableDataSource(membersActive);
        this._inviteV2Service.responsesArchivedDataSource = new MatTableDataSource(membersArchived);

      })

  }

  changeAllLetters (event) {
    this._inviteV2Service.invitesDataSource.data.forEach((item) => {
      item.selected = event.checked
    })
  }

  deleteLetter (element) {
    //console.log("element: " + JSON.stringify(element))

    let id = element.id;

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.member + "<br><br>Excluir esta carta?"}
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {

        console.log("deleteLetter id: " + id);
        console.log("this._eventService.currentEvent.id: " + this._eventService.currentEvent.id);

        this._letterV2Service.delete(id)
          .then(
            () => {
              this.loadLetters(this._eventService.currentEvent.id)
              this._inviteV2Service.invitesDataSource = null;
              this.letterSelected = new LetterV2();
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (err: any) => {console.log("delete invite error: " + err.message)}
          )

      }
    })

  }

  deleteInvite (invite) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '400px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme apagar", message: invite.member_name + "<br><br>" + this.letterSelected.name + "<br><br>APAGAR este convite?"}
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {

        this._inviteV2Service.delete(invite.id)
          .then(() => {
            this._inviteV2Service.loadAgendaForInvites(this._eventService.currentEvent.id, this.letterSelected.id)
            this.snackBar.openSnackBar("Sucesso!", '', 'success')
          }
          )
          .catch(
            (error) => {console.log("delete invite error: " + error.message)}
          )
      }

    })


  }
*/

  // ////////////////////////////

  openMemberDataDialog (element) {
    // console.log("element: " + JSON.stringify(element))

    let invites: any[] = []

    element.letters.forEach(invite => {

      invites.push({
        'invite_id': invite.id,
        'memberDataCheck': invite.memberDataCheck
      })
    });

    //   console.log("letters: " + JSON.stringify(letters))

    this._memberService.getById(element.id)
      .subscribe((result) => {
        const memberData: any = {
          "id": result.id,
          "data": result.data(),
          "urlUpdate": element.url_update,
          'invites': invites
        }

        let dialogRef = this.dialog.open(MemberDataDialogComponent, {
          width: '600px',
          height: '580px',
          panelClass: 'custom-dialog-container',
          data: memberData
        });

      })

  }

  selecteLocation (location_id) {
    const centerCurrent = this._conventionCenterService.conventionCenters.find((e) => {
      return e.id === location_id
    })
    this._conventionCenterService.conventionCenterCurrent = centerCurrent
    //console.log("selecteLocation: " +  JSON.stringify(this._conventionCenterService.conventionCenterCurrent))
  }

  selecteContext (context_id) {
    this._departmentService.contextCurrent = context_id
    console.log("this._departmentService.contextCurrent: " + this._departmentService.contextCurrent);
  }


  archiveItem (element) {
    const id = element.id
    const flag: boolean = element.archived ? true : false
    let text: string;

    if (flag) {
      text = 'desarquivar'
    } else {
      text = 'arquivar'
    }

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "<br>Deseja " + text + " este convite?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._inviteV2Service.archiveInvite(id, flag)
          .then(() => {
            this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log('erro')
          })
      }
    })
  }


}
